import ObjectivesImg from "modules/core/assets/img/modules/objectives_module_modal.png";
import PlaybooksImg from "modules/core/assets/img/modules/playbooks_module_modal.png";
import ScorecardImg from "modules/core/assets/img/modules/scorecard_module_modal.png";
import PeopleStatsImg from "modules/core/assets/img/modules/people_stats_module_modal.png";
import ProjectStatsImg from "modules/core/assets/img/modules/project_stats_module_modal.png";
import RoadmapImg from "modules/core/assets/img/modules/roadmap_module_modal.png";

import { UserFeatureModuleKey } from "modules/user/types/entities";

export const featureModuleContent: {
  [key in UserFeatureModuleKey]?: {
    title: string;
    description: string;
    listItems: string[];
    image: string;
    isNew: boolean;
    learnMoreLink?: string;
  };
} = {
  objectives: {
    title: "Objectives",
    description:
      "Say good bye to meaningless experimentation. Objectives lets you start the right way by focusing on the key goals you want to achieve and aligning all your experimentation efforts to achieve these goals.",
    image: ObjectivesImg,
    isNew: true,
    listItems: [
      "Create high-level company objectives & targets.",
      "Link your research, ideas and experiments directly to your objective targets.",
      "Track and manage your overall objective progress.",
      "Explore creative tactics to achieve new ways to solve old problems."
    ]
  },
  playbooks: {
    title: "Playbooks",
    description:
      "Say goodbye to the hassle of sharing PDFs, PowerPoints, or textbooks. From now on, you can access everything you need in a single, convenient location.",
    image: PlaybooksImg,
    isNew: true,
    listItems: [
      "Create your own tutorials, onboarding guides and operational procedures.",
      "View playbooks published by other team members.",
      "Archive irrelevant ones.",
      "Keep track of what has changed by viewing the playbook timeline."
    ]
  },
  experiment_scorecard: {
    title: "Experiment Health Score",
    description:
      "Ensure the integrity and success of your experiments with our Experiment Health Score. Instantly identify gaps in process adherence, catch integrity threats, and take action to improve your experimentation quality.",
    image: ScorecardImg,
    isNew: false,
    learnMoreLink:
      "https://intercom.help/efestra/en/articles/8717076-experiment-health-score-explained",
    listItems: [
      "Understand the complete health of your experiment during pre-live and post-live phases.",
      "See all the problematic areas of your experiments and possible integrity issues.",
      "Know what processes to address to increase your overall experiment quality and results."
    ]
  },

  people_stats: {
    title: "People Stats",
    description:
      "With the People Stats feature, you can effortlessly track all the activities of your team members. You can view when they were last active, their best role, and much more.",
    image: PeopleStatsImg,
    isNew: false,
    learnMoreLink:
      "https://intercom.help/efestra/en/articles/7234413-people-stats",
    listItems: [
      "See who your top performing users are and coach the ones falling behind.",
      "Compare user activity within a selected time range.",
      "Check the health score of experiments run by a specific user."
    ]
  },

  project_stats_v2: {
    title: "Project Stats",
    description:
      "Project Stats are created to visualise your project's progress and activity. They show how many items were created, the overall health score, implementation lag time, and more.",
    image: ProjectStatsImg,
    isNew: false,
    learnMoreLink:
      "https://intercom.help/efestra/en/articles/9245070-project-stats",
    listItems: [
      "See who your top performing teams and people are and coach the ones falling behind.",
      "Spot the bottlenecks that are preventing you from scaling your testing program.",
      "View performance of your entire program right from the company level all way down to individual teams and people."
    ]
  },

  roadmap: {
    title: "Roadmap",
    description:
      "Automated Gantt Charts provide Unparalleled visibility of your entire program timeline.",
    image: RoadmapImg,
    isNew: false,
    learnMoreLink:
      "https://intercom.help/efestra/en/articles/5426534-shared-roadmap-set-up",
    listItems: [
      "What experiments are coming up further down the line.",
      "Clashes and collisions when planning your experiments.",
      "A detailed roadmap that can be filtered and segmented to show you what you're looking for."
    ]
  }
};
